<script>
export default{
  name: 'CreateTemplateModal',
  data(){
    return{
      isCreating: true,
      isLoading: false,
      selectedLanguage: { name: "English", code: "en" },
      templateName: '',
      selectedCategory: "AUTHENTICATION",
      selectedFormat: "POSITIONAL",
      templateBody: null,
      selectedHeaderType: 'none',
      headerTypes: [
        { name: 'None', value: 'none' },
        { name: 'Text', value: 'text' },
        { name: 'Image', value: 'image' },
        { name: 'Video', value: 'video' },
        { name: 'Document', value: 'document' },
        { name: 'Location', value: 'location' }
      ],
      languages: [
        { name: "Afrikaans", code: "af" },
        { name: "Albanian", code: "sq" },
        { name: "Arabic", code: "ar" },
        { name: "Arabic (EGY)", code: "ar_EG" },
        { name: "Arabic (UAE)", code: "ar_AE" },
        { name: "Arabic (LBN)", code: "ar_LB" },
        { name: "Arabic (MAR)", code: "ar_MA" },
        { name: "Arabic (QAT)", code: "ar_QA" },
        { name: "Azerbaijani", code: "az" },
        { name: "Belarusian", code: "be_BY" },
        { name: "Bengali", code: "bn" },
        { name: "Bengali (IND)", code: "bn_IN" },
        { name: "Bulgarian", code: "bg" },
        { name: "Catalan", code: "ca" },
        { name: "Chinese (CHN)", code: "zh_CN" },
        { name: "Chinese (HKG)", code: "zh_HK" },
        { name: "Chinese (TAI)", code: "zh_TW" },
        { name: "Croatian", code: "hr" },
        { name: "Czech", code: "cs" },
        { name: "Danish", code: "da" },
        { name: "Dari", code: "prs_AF" },
        { name: "Dutch", code: "nl" },
        { name: "Dutch (BEL)", code: "nl_BE" },
        { name: "English", code: "en" },
        { name: "English (UK)", code: "en_GB" },
        { name: "English (US)", code: "en_US" },
        { name: "English (UAE)", code: "en_AE" },
        { name: "English (AUS)", code: "en_AU" },
        { name: "English (CAN)", code: "en_CA" },
        { name: "English (GHA)", code: "en_GH" },
        { name: "English (IRL)", code: "en_IE" },
        { name: "English (IND)", code: "en_IN" },
        { name: "English (JAM)", code: "en_JM" },
        { name: "English (MYS)", code: "en_MY" },
        { name: "English (NZL)", code: "en_NZ" },
        { name: "English (QAT)", code: "en_QA" },
        { name: "English (SGP)", code: "en_SG" },
        { name: "English (UGA)", code: "en_UG" },
        { name: "English (ZAF)", code: "en_ZA" },
        { name: "Estonian", code: "et" },
        { name: "Filipino", code: "fil" },
        { name: "Finnish", code: "fi" },
        { name: "French", code: "fr" },
        { name: "French (BEL)", code: "fr_BE" },
        { name: "French (CAN)", code: "fr_CA" },
        { name: "French (CHE)", code: "fr_CH" },
        { name: "French (CIV)", code: "fr_CI" },
        { name: "French (MAR)", code: "fr_MA" },
        { name: "Georgian", code: "ka" },
        { name: "German", code: "de" },
        { name: "German (AUT)", code: "de_AT" },
        { name: "German (CHE)", code: "de_CH" },
        { name: "Greek", code: "el" },
        { name: "Gujarati", code: "gu" },
        { name: "Hausa", code: "ha" },
        { name: "Hebrew", code: "he" },
        { name: "Hindi", code: "hi" },
        { name: "Hungarian", code: "hu" },
        { name: "Indonesian", code: "id" },
        { name: "Irish", code: "ga" },
        { name: "Italian", code: "it" },
        { name: "Japanese", code: "ja" },
        { name: "Kannada", code: "kn" },
        { name: "Kazakh", code: "kk" },
        { name: "Kinyarwanda", code: "rw_RW" },
        { name: "Korean", code: "ko" },
        { name: "Kyrgyz (Kyrgyzstan)", code: "ky_KG" },
        { name: "Lao", code: "lo" },
        { name: "Latvian", code: "lv" },
        { name: "Lithuanian", code: "lt" },
        { name: "Macedonian", code: "mk" },
        { name: "Malay", code: "ms" },
        { name: "Malayalam", code: "ml" },
        { name: "Marathi", code: "mr" },
        { name: "Norwegian", code: "nb" },
        { name: "Pashto", code: "ps_AF" },
        { name: "Persian", code: "fa" },
        { name: "Polish", code: "pl" },
        { name: "Portuguese (BR)", code: "pt_BR" },
        { name: "Portuguese (POR)", code: "pt_PT" },
        { name: "Punjabi", code: "pa" },
        { name: "Romanian", code: "ro" },
        { name: "Russian", code: "ru" },
        { name: "Serbian", code: "sr" },
        { name: "Sinhala", code: "si_LK" },
        { name: "Slovak", code: "sk" },
        { name: "Slovenian", code: "sl" },
        { name: "Spanish", code: "es" },
        { name: "Spanish (ARG)", code: "es_AR" },
        { name: "Spanish (CHL)", code: "es_CL" },
        { name: "Spanish (COL)", code: "es_CO" },
        { name: "Spanish (CRI)", code: "es_CR" },
        { name: "Spanish (DOM)", code: "es_DO" },
        { name: "Spanish (ECU)", code: "es_EC" },
        { name: "Spanish (HND)", code: "es_HN" },
        { name: "Spanish (MEX)", code: "es_MX" },
        { name: "Spanish (PAN)", code: "es_PA" },
        { name: "Spanish (PER)", code: "es_PE" },
        { name: "Spanish (SPA)", code: "es_ES" },
        { name: "Spanish (URY)", code: "es_UY" },
        { name: "Swahili", code: "sw" },
        { name: "Swedish", code: "sv" },
        { name: "Tamil", code: "ta" },
        { name: "Telugu", code: "te" },
        { name: "Thai", code: "th" },
        { name: "Turkish", code: "tr" },
        { name: "Ukrainian", code: "uk" },
        { name: "Urdu", code: "ur" },
        { name: "Uzbek", code: "uz" },
        { name: "Vietnamese", code: "vi" },
        { name: "Zulu", code: "zu" }
      ]
    }
  }
}
</script>

<template>
  <div class="fixed inset-0 z-40 flex items-center justify-center p-4 my-4">
    <div 
      class="fixed inset-0 z-40 bg-slate-800/20 dark:bg-slate-800/50"
    ></div>

    <div 
      class="w-[560px] max-h-full overflow-y-auto top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 bg-white dark:bg-slate-700 dark:text-slate-100 p-4 rounded-md fixed z-50 transition-all duration-300 ease-in-out flex flex-col"
    >
      <div class="flex gap-2">
        <label for="template_name" class="flex-1 text-sm">
          Name your template
          <div class="has-[:focus]:border-woot-500 border-2 rounded-md flex gap-2 px-2 justify-between items-center">
            <input 
              id="template_name" type="text" maxlength="512" 
              v-model="templateName" placeholder="Enter a template name" 
              class="reset-base flex-1 h-[50px] focus:outline-none focus:ring-0" />
            <span class="text-xs text-slate-600 dark:text-white">{{ templateName.length || 0 }} / 512</span>
          </div>
        </label>

        <div>
          Select language
          <multiselect
            v-model="selectedLanguage"
            :options="languages"
            :searchable="true"
            :close-on-select="true"
            :clear-on-select="false"
            :preserve-search="true"
            label="name"
            track-by="code"
            placeholder="Pick a language"
          />
        </div>
      </div>

      <div class="flex justify-between">
        <label>
          Categories
          <select v-model="selectedCategory">
            <option value="AUTHENTICATION">Authentication</option>
            <option value="MARKETING">Marketing</option>
            <option value="UTILITY">Utility</option>
          </select>
        </label>

        <label>
          <span class="flex gap-2">
            <p>Variable</p> 
            <fluent-icon icon="info" size="12" v-tooltip.bottom-end="{
              content: `
                <strong>Type of variable</strong><br>
                Variables are placeholders for dynamic data in your template.<br><br>
                <strong>Examples:</strong><br>
                • Name: <code>{{order_id}}</code><br>
                • Number: <code>{{1}}</code>
              `,
              html: true,  // Allows HTML rendering
              theme: 'tooltip-custom'  // Optional styling class
            }" />
          </span>
          <select v-model="selectedFormat">
            <option value="POSITIONAL">Number</option>
            <option value="NAMED">Name</option>
          </select>
        </label>
      </div>
      

      <fieldset class="border-2 rounded-md p-4 mb-4">
        <legend class="px-2">Component</legend>
        <label>
          Header
          <select v-model="selectedHeaderType">
            <option v-for="(type, index) in headerTypes" :key="index" :value="type.value">{{ type.name }}</option>
          </select>
          <input type="text" v-if="selectedHeaderType == 'text'" :placeholder="`Enter text in ${selectedLanguage.name}`"/>
        </label>

        <label>
          Body
          <textarea 
            v-model="templateBody"
            rows="4"
          />
        </label>

        <label>
          Footer
          <input type="text" placeholder="Enter text"/>
        </label>
      </fieldset>

      <fieldset class="border-2 rounded-md p-4 mb-4">
        <legend class="px-2">Buttons.<span class="text-slate-600">optional</span></legend>
        <p class="text-xs text-slate-600">Create buttons that let customers respond to your message or take action. You can add up to ten buttons. If you add more than three buttons, they will appear in a list.</p>
        <div class="flex justify-end w-full">
          <woot-button icon="add" variant="clear">Add Buttons</woot-button>
        </div>
      </fieldset>

      <fieldset class="border-2 rounded-md p-4 mb-4">
        <legend class="px-2">Message validity period</legend>
        <p class="text-xs text-slate-600">You can set a custom validity period that your utility message must be delivered by before it expires. If a message has not been delivered within this time frame, you will not be charged and your customer will not see the message.</p>
        <p class="flex flex-col">
          <strong>Set custom validity period for your message</strong>
          <span class="text-slate-600 text-sm">If you don't set a custom validity period, the standard 10 minutes WhatsApp message validity period will be applied.</span>
        </p>
      </fieldset>

      <div class="flex justify-end gap-4 mt-4">
        <woot-button variant="clear" color-scheme="secondary" @click="$emit('close')">Cancel</woot-button>
        <woot-button 
          variant="clear" 
          color-scheme="primary"
          :disabled="isLoading" 
        >{{ isLoading ? 'Loading' : ( isCreating ? 'Create' : 'Submit for preview' ) }}</woot-button>
      </div>
    </div>
  </div>
</template>